import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Application } from '../../../../common/models/application.interface';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { ApplicationService } from '../../shared/services/application.service';
import {
    GetApplicationListRequest,
    GetApplicationListRequestSuccess
} from './utils.action';

@Injectable()
export class UtilsEffects {
    @Effect()
    listAllApplications$: Observable<Action> = this.actions$.pipe(
        filter((action: Action) => {
            return action instanceof GetApplicationListRequest;
        }),
        mergeMap((action: Action) => this.applicationService.list()),
        map(
            (response: ApiResponse<Application[]>) =>
                new GetApplicationListRequestSuccess(response.data)
        )
    );

    constructor(
        private actions$: Actions,
        private applicationService: ApplicationService
    ) {}
}
